const messagesDe = {
  accessCodeRequired:
    'Für dieses exklusive Angebot ist der von Ihrer Organisation bereitgestellte Zugangscode erforderlich.',
  accessOffer: 'Zugangsangebot',
  add: 'Hinzufügen',
  addOption: 'Option hinzufügen',
  addOptionToAllParticipants: 'Option für alle Teilnehmer hinzufügen',
  addParticipant: 'Teilnehmer aufnehmen',
  addParticipantInfo: 'Teilnehmerinformationen hinzufügen Nummer {numberParticipant}',
  addToCart: 'In den Warenkorb legen',
  afternoon: 'Nachmittag',
  age: 'Alter',
  ageBetween: 'Das Alter muss zwischen {min} und {max} Jahren liegen.',
  appliedPromotions: 'Angewandte Promotionen',
  availability: 'Verfügbarkeit',
  back: 'Zurück',
  backToProduct: 'Zurück zum Produkt',
  black: '{count, plural, one {# schwarze} other {# schwarze}}',
  blue: '{count, plural, one {# blaue} other {# blaue}}',
  cancel: 'Abbrechen',
  cartActionCheckout: 'Zur Kasse',
  cartActionClear: 'Warenkorb leeren',
  cartAriaOpen: 'Warenkorb öffnen',
  cartAriaRemoveParticipant: 'Diesen Teilnehmer entfernen',
  cartAriaRemoveProduct: 'Dieses Produkt entfernen',
  cartClearBody:
    'Alle Produkte und Teilnehmer werden entfernt. Sie müssen Ihre Auswahl neu erstellen.',
  cartClearConfirm: 'Warenkorb leeren',
  cartClearTitle: 'Gesamten Warenkorb leeren?',
  cartDialogCancel: 'Abbrechen',
  cartEmptyBodyDrawer:
    'Durchsuchen Sie den Katalog und fügen Sie Ihre ersten Produkte hinzu.',
  cartEmptyTitle: 'Ihr Warenkorb ist leer',
  cartOptionCount: '{count, plural, one {# Option} other {# Optionen}}',
  cartParticipantCount: '{count, plural, one {# Teilnehmer} other {# Teilnehmer}}',
  cartRemoveProductBody:
    'Alle Teilnehmer und Optionen werden entfernt. <strong>Diese Aktion kann nicht rückgängig gemacht werden.</strong>',
  cartRemoveProductConfirm: 'Dieses Produkt entfernen',
  cartRemoveProductTitle: 'Dieses Produkt aus dem Warenkorb entfernen?',
  cartStepLabel: 'WARENKORB',
  cartSubTotal: 'Zwischensumme',
  cartTitle: 'Mein Warenkorb',
  cartTitleParticipantCount:
    '· {count, plural, one {# Teilnehmer} other {# Teilnehmer}}',
  cartTotal: 'Gesamt',
  cartTotalTaxSub: 'inkl. MwSt.',
  cartTrustFlexible: 'Flexible Stornierung',
  cartTrustSecure: 'Sichere Zahlung',
  checkSpecialInfo: 'Prüfen Sie spezielle Informationen für diese Dauer!',
  chooseATimeslot: 'Wählen Sie ein Zeitfenster:',
  chooseValidityCategory: 'Wählen Sie eine Dauer von {validityCategoryName} für dieses Produkt.',
  close: 'Schließen',
  closeModal: 'Dieses Modal schließen',
  code: 'Code',
  confirm: 'Bestätigen',
  confirmParticipants: 'Teilnehmer bestätigen',
  continue: 'Fortfahren',
  date: 'Datum',
  discount: 'Rabatt',
  discover: 'Entdecken Sie',
  domainInformation: 'Bereichsinformationen',
  duration: 'Dauer',
  'dynamicPriceCalendar.bestPrice': 'bester Preis',
  'dynamicPriceCalendar.chooseDayAriaLabelPrefix': 'Wählen',
  'dynamicPriceCalendar.defaultCategoryName': 'Erwachsenen',
  'dynamicPriceCalendar.disabledDayAriaLabelPrefix': 'Nicht verfügbar',
  'dynamicPriceCalendar.disclaimer':
    'Angezeigte Preise gelten für 1 {categoryName}, in {currency}, aufgerundet, können je nach Verfügbarkeit variieren und werden bei der Auswahl der Teilnehmer bestätigt.',
  'dynamicPriceCalendar.inRange': 'in der Auswahl',
  'dynamicPriceCalendar.monthAriaLabelPrefix': 'Kalender',
  'dynamicPriceCalendar.nextMonthAriaLabel': 'Nächster Monat',
  'dynamicPriceCalendar.originalPrice': 'ursprünglicher Preis',
  'dynamicPriceCalendar.previousMonthAriaLabel': 'Vorheriger Monat',
  'dynamicPriceCalendar.selectedDate': 'ausgewählt',
  'dynamicPriceCalendar.unavailable': 'nicht verfügbar',
  dynamicPriceDiscount: 'Sie profitieren von einem Aktionstarif!',
  edit: 'Bearbeiten',
  error: 'Fehler',
  errorPageMessage1: 'So sollte die Geschichte nicht laufen.',
  errorPageMessage2: 'Wir arbeiten daran und werden alles in Kürze wieder in Ordnung bringen.',
  errorPageTitle: 'Entschuldigung, wir haben ein Problem...',
  finalPrice: 'Endpreis',
  found: 'Wir fanden',
  free: 'Kostenlos',
  goBackToHome: 'Zurück zur Startseite',
  green: '{count, plural, one {# grüne} other {# grüne}}',
  howOldIsTheParticipant: 'Wie alt ist dieser Teilnehmer?',
  includedAdvantages: 'In diesem Angebot enthaltene Vorteile',
  indicativePrice: 'Richtpreis für 1 Teilnehmer, 1 Tag',
  initialPrice: 'Ursprünglicher Preis',
  invalidProductCode: 'Dieser Code ist ungültig',
  kmOfSlopes: 'km Pisten',
  loading: 'Laden...',
  moreInformation: 'Mehr Informationen',
  morning: 'Vormittag',
  noData: 'Keine Daten gefunden',
  noDateSelected: 'Kein Datum ausgewählt',
  noDomainAvailable: 'Derzeit kein Bereich verfügbar.',
  noDurationAvailable: 'Derzeit keine Dauer verfügbar.',
  noOptionSelected: 'Keine Option ausgewählt',
  noParticipant: 'Keine Teilnehmer',
  noProductForSelectedDuration:
    'Informationen konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
  noSeats: 'Keine Zeitfenster mehr für die Buchung verfügbar.',
  options: 'Optionen',
  participant: 'Teilnehmer',
  participants: 'Teilnehmer',
  participantsReachedLimit: 'Die maximale Teilnehmerzahl wurde erreicht.',
  perAdult: 'Pro Erwachsener',
  priceDetails: 'Details zum Preis',
  priceSummary: 'Zusammenfassung des Preises',
  red: '{count, plural, one {# rote} other {# rote}}',
  refreshPage: 'Seite aktualisieren',
  remove: 'Entfernen',
  resort: 'Resort',
  restrictedAccess: 'Eingeschränkter Zugang',
  results: 'ergebnisse',
  seats: '{count, plural, one {# Platz} other {# Plätze}}',
  seeLess: 'Weniger sehen',
  seeMore: 'Mehr sehen',
  selectDates: 'Daten auswählen',
  selectOptions: 'Wählen Sie Optionen aus',
  selectOrDeselectParticipants: 'Teilnehmer auswählen oder abwählen:',
  showPricesFor: 'Preise anzeigen für:',
  skiLifts: 'Skilifte',
  slopes: 'Pisten',
  slopesBreakdown: 'Pistenaufteilung',
  specialInfo: 'Besondere Informationen',
  timeslots: 'Zeitfenster',
  today: 'Heute',
  tomorrow: 'Morgen',
  total: 'Gesamt',
  unableToCalculatePrice:
    'Der Preis kann nicht berechnet werden. Bitte versuchen Sie es später noch einmal.',
  undatedProductMessage: 'Kein Datum erforderlich',
  viewDetails: 'Details anzeigen',
  yearsNumber: '{count, plural, one {# Jahr} other {# Jahre}}',
  yearsRange: '{ageMin}-{ageMax} Jahre',
  youSaved: 'Sie sparen',
  domain: 'Gebiet',
  chooseDomain: 'Wählen Sie das Gebiet {categoryName}',
  buy: 'Kaufen',
  purchaseDrawerTitle: 'Ihre Auswahl',
  'purchaseCallToAction.title': 'Kauf & Aufladung',
  'purchaseCallToAction.subtitle':
    'Wählen Sie Ihre Daten und die Anzahl der Teilnehmer für einen sofortigen Kauf oder eine Aufladung.',
  'purchaseCallToAction.buttonLabel': 'Jetzt buchen',
  purchaseStepConfiguration: 'KONFIGURATION',
  purchaseStepOptions: 'OPTIONEN',
  closeConfirmationTitle: 'Noch nicht bereit zu bestellen?',
  closeConfirmationDescription:
    'Ihre aktuelle Auswahl geht verloren, wenn Sie jetzt die Seite verlassen.',
  closeConfirmationKeep: 'Buchung fortsetzen',
  closeConfirmationLeave: 'Verlassen',
  'upsell.dateChanged': 'Ihre Aufenthaltsdaten wurden geändert',
  'upsell.days': '{count, plural, one {# Tag} other {# Tage}}',
  'upsell.included': 'Inklusive',
  'upsell.moreInfo': 'Mehr erfahren',
  'upsell.select': 'Auswählen',
  'upsell.title': 'Upgraden Sie Ihren Pass',
};

export default messagesDe;
